module.exports = "## Toolbar\n\n[Toolbars](https://www.google.com/design/spec/layout/structure.html#structure-toolbars) are collections of components stacked horizontally against each other.\nToolbars provide greater versatility than AppBars which are a subset of toolbars.\nThe following toolbar components can help organize your layout.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Toolbar/README.md
 ** module id = 1091
 ** module chunks = 0
 **/